export default "<app-table [inputConfig]=\"configuration\"></app-table>\n"